import find from 'lodash/find';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';

import {setAttributes} from 'js-utils/analytics';
import {getWindowObject} from 'js-utils/feature-detection';
import {denormalize} from 'js-utils/transformation';
import {
    formatUrl,
    parseQuery,
} from 'url-lib';
import {
    trackEventFromState,
    trackInitialPageView,
} from '@eb/site-analytics';

import {getCanonicalSearchUrl} from '@eb/destination-utils';
import {trackInternalAppClick} from '../analytics';
import {logDiscoveryRequest} from '../api/analytics';
import {
    logManualEventCheckpoint,
    logSearchPageViewCheckpoints,
} from '../utils/janus';

import {
    GA_SEARCH_CATEGORY,
    GA_ENTER_MAP_VIEW,
    NON_MANUAL_SOURCES,
    SEARCH_EVENT_NAVIGATION,
    GA_PAGE_LOAD_ACTION,
    GOOGLE_OPTIMIZE_SEARCH_EXPERIMENT_ID,
} from '../constants';
import {getSearchId} from '../utils/analytics';


export const trackEventClickInternal = (data) => (
    (dispatch, getState) => {
        const {
            search: {
                searchId,
                eventSearch,
            },
            app: {
                guestId,
            },
        } = getState();

        const searchMetricId = getSearchId({eventSearch, guestId});

        trackInternalAppClick({searchId, searchMetricId, guestId, ...data});
    }
);

export const removeNullExperiments = (experiments = {}) => (
    Object.keys(experiments)
        .reduce((prev, expName) => (
            (experiments[expName] && experiments[expName] !== 'None') ? {...prev, [expName]: experiments[expName]} : prev
        ), {})
);

const _getCurrentPath = (eventSearch, serverUrl, slug) => {
    const location = getWindowObject('location');

    let currentPath;

    if (location) {
        currentPath = location.href || '';
    } else {
        currentPath = '';
    }

    const canonicalSearchUrl = getCanonicalSearchUrl({
        ...eventSearch,
        slug,
    });

    const path = `${serverUrl}${canonicalSearchUrl}`;

    if (eventSearch.q) {
        const queryParams = currentPath.includes('?') ? parseQuery(currentPath) : {};

        currentPath = formatUrl(
            path,
            {
                ...queryParams,
                q: eventSearch.q,
            }
        );
    }
    return currentPath;
};

/*
When a page is viewed there are several logs that are notified.
 */
export const trackPageView = (isBrowsePage) => (
    (dispatch, getState) => {
        const {
            app: {
                guestId,
                publicId,
                serverUrl,
                experiments,
            },
            gaSettings,
            search: {
                eventSearch,
            },
            location: {
                slug,
            },
            pagination: {
                currentPage,
                event,
            },
            content: {
                entities,
            },
            kompariExperimentId,
        } = getState();

        const gaDimensions = {};

        const manualEventCheck = ({ticketsBy}) => ticketsBy && !NON_MANUAL_SOURCES.includes(ticketsBy);

        let shouldLogManualEvent = false;

        const eventIds = event[currentPage] ? event[currentPage].ids : [];

        const experimentsWithOptimize = {
            ...experiments,
            newSearch: window.google_optimize ? window.google_optimize.get(GOOGLE_OPTIMIZE_SEARCH_EXPERIMENT_ID) : null,
        };
        const cleanedExperiments = removeNullExperiments(experimentsWithOptimize);

        if (isBrowsePage) {
            shouldLogManualEvent = find(values(entities), manualEventCheck);

            if (kompariExperimentId) {
                gaDimensions.experimentId = kompariExperimentId;
            }
        } else {
            shouldLogManualEvent = find(denormalize(eventIds, entities), manualEventCheck);

            const searchId = logDiscoveryRequest({
                eventSearch,
                publicUserId: publicId,
                guestId,
                locationSlug: slug,
                //userGenerated is always unknown at this point in code
                // - did the user change the search or just click a SEO link?
                userGenerated: null,
                navigation: SEARCH_EVENT_NAVIGATION,
                action: GA_PAGE_LOAD_ACTION,
                // variant can be used to track experiments
                variant: JSON.stringify(cleanedExperiments),
                resultIds: eventIds,
                numResults: event[currentPage] ? event[currentPage].objectCount : null,
            });

            if (searchId) {
                gaDimensions.searchId = searchId;
            }

            /* We want to log destination_search_page_viewed for every client
            side update because we are showing new content to the user each time.
            Additionally aligns with our GA approach for pageviews on SPAs */
            logSearchPageViewCheckpoints();
        }
        logManualEventCheckpoint(shouldLogManualEvent);


        const currentPath = _getCurrentPath(eventSearch, serverUrl, slug);

        setAttributes({location: currentPath});
        if (!isEmpty(cleanedExperiments)) {
            gaDimensions.experimentId = JSON.stringify(cleanedExperiments);
        }
        trackInitialPageView(gaSettings, {dimensions: gaDimensions});
    }
);

export const trackEnterMapView = () => (
    (dispatch, getState) => {
        const state = getState();
        const {
            location: {
                location,
            },
        } = state;

        trackEventFromState(state, {label: location, category: GA_SEARCH_CATEGORY, action: GA_ENTER_MAP_VIEW});
    }
);
